import { render, staticRenderFns } from "./ListCredenciamentoPF.vue?vue&type=template&id=b7199e5e"
import script from "./ListCredenciamentoPF.vue?vue&type=script&lang=js"
export * from "./ListCredenciamentoPF.vue?vue&type=script&lang=js"
import style0 from "./ListCredenciamentoPF.vue?vue&type=style&index=0&id=b7199e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports